/*
 * @Author: your name
 * @Date: 2020-05-07 09:53:39
 * @LastEditTime: 2020-05-12 10:58:23
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \gta_aitraining_vue\public\blockly\msg\zh-hans.js
 */
"use strict";
import Blockly from "blockly";

Blockly.Msg["TEXT_PRINT_HELPURL"] =
  "https://github.com/google/blockly/wiki/Text#printing-text"; // untranslated

export default {
  title: "代码",
  blocks: "块",
  linkTooltip: "保存模块并生成链接。",
  runTooltip: "于工作区中运行块所定义的程式。",
  badCode: "程序错误：\n%1",
  timeout: "超过最大执行行数。",
  trashTooltip: "放弃所有块。",
  catEvent: "事件",
  catLogic: "逻辑",
  // catLoops: "循环",
  catLoops: "控制",
  // catMath: "数学",
  catMath: "运算",
  catText: "字符串",
  catLists: "列表",
  catDict: "字典",
  catTurtle: "海龟库",
  // catColour: "颜色",
  catColour: "绘图",
  catDataType: "类型",
  catVariables: "变量",
  catFunctions: "函数",
  listVariable: "列表",
  textVariable: "文本",
  httpRequestError: "请求存在问题。",
  linkAlert: "通过这个链接分享您的模块：\n\n%1",
  hashError: "对不起，没有任何已保存的程序对应'%1' 。",
  xmlError: "无法载入您保存的文件。您是否使用其他版本的Blockly创建该文件的？",
  badXml:
    "XML解析错误：\n%1\n\n选择“确定”以取消您对XML的修改，或选择“取消”以继续编辑XML。"
};
